import script from "./BoardItemModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BoardItemModal.vue?vue&type=script&setup=true&lang=ts"

import "./BoardItemModal.vue?vue&type=style&index=0&id=226132c5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-226132c5"]])

export default __exports__